export default __webpack_public_path__ + "static/media/rep_5.c0a0ff64.mp3";